export const media = {
    namespaced: true,   
    state: {        
        mediaFile: "",
    },
    actions: {
        setMediaFile({ commit }, file) {
            commit('addMediaFile', file)
        },
    },
    mutations: {
        addMediaFile(state, file) {
            state.mediaFile = file;
        },
    }

    //state: {
    //    mediaFiles: [],
    //},
    //actions: {
    //    setPushMediaFile({ commit }, file) {
    //        commit('pushMediaFile', file);
    //    },
    //    setPushMediaFiles({ commit }, files) {
    //        commit('pushMediaFiles', files);
    //    },
    //    setClearMediaFiles({ commit }) {
    //        commit('clearMediaFiles');
    //    },
    //},
    //mutations: {
    //    pushMediaFile(state, file) {
    //        state.mediaFiles.push(file);
    //    },
    //    pushMediaFiles(state, files) {
    //        state.mediaFiles.push(...files);
    //    },
    //    clearMediaFiles(state) {
    //        state.mediaFiles = [];
    //    },
    //}
};